import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, verifyAddress } from '@web/utils';
import { env } from '@/env';
import { ButtonWithLoading } from '../ButtonWithLoading';

interface AddressValidationInputProps {
  setValue: (name: string, value: string) => void;
  setCoordinates: (coordinates: { lat: number; long: number }) => void;
}

const AddressValidationInput: React.FC<AddressValidationInputProps> = (
  props,
) => {
  const { setValue, setCoordinates } = props;
  const { t } = useTranslation();

  const [addressToValidate, setAddressToValidate] = useState<string>('');
  const [isLoading, setLoading] = useState<boolean>(false);
  const [addressValidationError, setAddressValidationError] =
    useState<string>('');

  const handleVerifyAddress = async () => {
    setLoading(true);

    try {
      const verifiedAddress = await verifyAddress(
        addressToValidate,
        env.VITE_GOOGLE_API_KEY,
      );
      const { isVerified, formattedAddress, postalAddress, coordinates } =
        verifiedAddress;

      if (isVerified && postalAddress) {
        setValue('addressLine1', postalAddress.addressLines[0]);
        setValue('addressPostcode', postalAddress.postalCode);
        setValue('addressLocality', postalAddress.locality);
        if (coordinates) setCoordinates(coordinates);
        setAddressToValidate('');
        setAddressValidationError('');
      } else {
        setAddressValidationError(
          'Validation error, please try again or enter manually',
        );
      }
      setLoading(false);
      console.log({ isVerified, formattedAddress, postalAddress });
    } catch (error) {
      console.log('error from verifyAddress', error);
    }
  };

  return (
    <div className="mt-1-0 flex w-full items-center justify-between">
      <div className="w-full mr-1-0">
        <Input
          disabled={isLoading}
          value={addressToValidate}
          onChange={(_, value) => setAddressToValidate(value.toString())}
          placeholder={t('global.search') ?? ''}
        />
        {addressValidationError && (
          <p className="absolute text-1-4 italic text-red">
            {addressValidationError}
          </p>
        )}
      </div>
      <ButtonWithLoading
        isLoading={isLoading}
        isDisabled={!addressToValidate}
        handleClick={handleVerifyAddress}
      />
    </div>
  );
};

export default AddressValidationInput;
